import { useRef, FormEvent, FC, useState, useEffect } from "react";
import { OldApi } from "../api/api";
import { IVacancy } from "../utils/types";
import { useTranslation } from "react-i18next";
import { getCurrentLocale } from "../i18n";
import PopupAccess from "./PopupAccess";
import { toast } from "react-toastify";

interface IPopupVacancyProps {
  vacancy: IVacancy;
  onClose: () => void;
}

const PopupVacancy: FC<IPopupVacancyProps> = ({ vacancy, onClose }) => {
  const currentLocale = getCurrentLocale();
  const { t } = useTranslation();
  const [file, setFile] = useState<File | null>(null);
  const [success, setSuccess] = useState<boolean>(false);
  const nameRef = useRef<HTMLInputElement>(null);
  const emailRef = useRef<HTMLInputElement>(null);
  const phoneRef = useRef<HTMLInputElement>(null);

  const handleSubmit = async (event: FormEvent<HTMLFormElement>) => {
    event.preventDefault();

    const name = nameRef.current?.value;
    const email = emailRef.current?.value;
    const phone = Number(phoneRef.current?.value);

    if (name && email && phone && file) {
      const response = await toast.promise(
        OldApi.vacancyApply({ email, name, phone, file: file }),
        {
          pending: t("toast:promise.pending"),
          success: t("toast:promise.success"),
          error: t("toast:promise.error"),
        }
      );

      if (response.success) {
        setSuccess(true);
        // onClose();
      } else {
        toast.error(t("toast:error"));
      }
      // formData.append('name', name);
      // formData.append('email', email);
      // formData.append('phone', phone);

      // const file = docInput.files[0];
      // formData.append('file', file);
    } else {
      toast.error(t("toast:allFieldsMustBeFilledIn"));
    }
    // onClose();
  };

  const handleBackgroundClick = (e: any) => {
    if (e.target.className === "popup") {
      onClose();
    }
  };

  useEffect(() => {
    document.ontouchmove = (event) => {
      if (event.touches.length === 1) {
        event.preventDefault();
      }
    };
    document.body.style.overflow = "hidden";
    return () => {
      document.ontouchmove = (event) => {
        event.stopPropagation();
        event.stopImmediatePropagation();
      };
      document.body.style.overflow = "initial";
    };
  }, []);

  return success ? (
    <PopupAccess onClose={onClose} position={vacancy.name} />
  ) : (
    <div className="popup-wrapper" onClick={handleBackgroundClick}>
      <input type="checkbox" className="popup-checkbox" id="popupCheckboxOne" />
      <div className="popup">
        <div className="popup-content">
          <label
            htmlFor="popupCheckboxOne"
            className="popup-closer"
            onClick={onClose}
          >
            &#215;
          </label>
          <div className="address-contact">
            <p className="vacancy-name">{vacancy.name}</p>
          </div>
          <div className="address-contact-content">
            <form method="post" onSubmit={handleSubmit}>
              <div className="form-row">
                <input
                  placeholder=" "
                  type="text"
                  id="name"
                  name="name"
                  required
                  autoComplete="off"
                  ref={nameRef}
                  onKeyPress={(event) => {
                    if (event.key === "Enter") {
                      event.preventDefault();
                    }
                  }}
                />
                <label htmlFor="name">{t("vacancies:name")} *</label>
              </div>
              <div className="form-row">
                <input
                  placeholder=" "
                  type="email"
                  id="email"
                  name="email"
                  required
                  autoComplete="off"
                  ref={emailRef}
                  onKeyPress={(event) => {
                    if (event.key === "Enter") {
                      event.preventDefault();
                    }
                  }}
                />
                <label htmlFor="email">{t("vacancies:email")} *</label>
              </div>
              <div className="form-row">
                <input
                  placeholder=" "
                  type="tel"
                  id="phone"
                  name="phone"
                  required
                  autoComplete="off"
                  ref={phoneRef}
                  pattern="[0-9]*"
                  onKeyPress={(event) => {
                    if (!/[0-9]/.test(event.key) || event.key === "Enter") {
                      event.preventDefault();
                    }
                  }}
                />
                <label htmlFor="phone">{t("vacancies:phone")} *</label>
              </div>
              <div className="add-document">
                <input
                  type="file"
                  name="document"
                  id="document"
                  // @ts-ignore
                  onChange={(e) => setFile(e.target.files[0])}
                />
                <label htmlFor="document">{t("vacancies:attachCV")} *</label>
              </div>
              {file && (
                <div className="selected-document">
                  <span className="selected-document-text">{file.name}</span>
                  <span
                    onClick={() => setFile(null)}
                    className="selected-document-cross"
                  >
                    &#215;
                  </span>
                </div>
              )}
              <div className="btn">
                <button className="btn1" type="button" onClick={onClose}>
                  {t("vacancies:cancel")}
                </button>
                <button className="btn2">
                  <span className="btn2-span">{t("vacancies:send")}</span>
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PopupVacancy;
